import React from 'react'
import CountUp from './CountUp'
import styles from './index.module.css'

const stats = [
  { target: 100, suffix: '+', label: 'Trusted Clients' },
  { target: 5, suffix: '+', label: 'Years in Business' },
  { target: 10, suffix: 'M+', label: 'Daily Sales' },
  { target: 99.9, suffix: '%', label: 'System Uptime', decimals: 1 },
]

const BusinessGrowSection = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.innerDiv}>
        <div className={styles.titleSection}>
          <h2 className={styles.heading}>Epinics By Numbers</h2>
          <p className={styles.subHeading}>The numbers behind our growing impact</p>
        </div>

        <div className={styles.statsRow}>
          {stats.map((stat) => (
            <div key={stat.label} className={styles.statItem}>
              <div className={styles.number}>
                <CountUp
                  target={stat.target}
                  duration={1200}
                  decimals={stat.decimals || 0}
                />
                <span>{stat.suffix}</span>
              </div>
              <div className={styles.label}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BusinessGrowSection
